export class CsvUtils {
  static convertToCSV<T>(objArray: T[], headerList: string[]): string {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';

    // Add header row
    for (const index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1); // Remove trailing comma
    str += row + '\r\n';

    // Add data rows
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (const index in headerList) {
        const head = headerList[index];
        const value = array[i][head] as string;
        line += this.escapeCsvField(value) + ',';
      }
      line = line.slice(0, -1); // Remove trailing comma
      str += line + '\r\n';
    }
    return str;
  }

  static escapeCsvField(value: string): string {
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      // Escape internal double quotes
      const escapedValue = value.replace(/"/g, '""');
      // Enclose the entire field in double quotes
      return `"${escapedValue}"`;
    }
    return value;
  }

  static downloadFile<T>(data: T[], headerList: string[], filename = 'csvExport'): void {
    const csvData = this.convertToCSV(data, headerList);

    const blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;',
    });
    const fileDownloadElement = document.createElement('a');
    const url = URL.createObjectURL(blob);

    fileDownloadElement.setAttribute('href', url);
    fileDownloadElement.setAttribute('download', filename + '.csv');
    fileDownloadElement.style.visibility = 'hidden';
    document.body.appendChild(fileDownloadElement);
    fileDownloadElement.click();
    document.body.removeChild(fileDownloadElement); // Clean up
    URL.revokeObjectURL(url); // Release object URL
  }
}
